export {
  type TransformHttpErrorToPtHttpErrorResponseFn,
  type HandleIdentifiedErrorFn,
  type HttpErrorOptions,
  provideHttpErrorOptions,
} from './lib/http-error-options';
export { BackendErrorWithMessageError } from './lib/http/http-error/backend-error-with-message.error';
export {
  type ResolvedFieldError,
  type FieldErrorResolver,
  FieldError,
} from './lib/http/http-error/field.error';
export { handleMaintenanceModeError } from './lib/http/http-error/maintenance-mode-error/handle-maintenance-mode-error';
export { MaintenanceModeError } from './lib/http/http-error/maintenance-mode-error/maintenance-mode.error';
export { handleNoInternetConnectionError } from './lib/http/http-error/no-internet-connection-error/handle-no-internet-connection-error';
export { NoInternetConnectionError } from './lib/http/http-error/no-internet-connection-error/no-internet-connection.error';
export { handleNotFoundEndpointError } from './lib/http/http-error/not-found-endpoint-error/handle-not-found-endpoint-error';
export { NotFoundEndpointError } from './lib/http/http-error/not-found-endpoint-error/not-found-endpoint.error';
export { handleNotFoundServerError } from './lib/http/http-error/not-found-server-error/handle-not-found-server-error';
export { NotFoundServerError } from './lib/http/http-error/not-found-server-error/not-found-server.error';
export { I18nProviderInjectionToken } from './lib/i18n/i18n.scope';
export {
  DISABLE_HTTP_GLOBAL_ERROR_TO_BE_HANDLED,
  type DisableErrorCode,
} from './lib/disable-error-code';
export { handleHttpError } from './lib/http/handle-http-error';
export { HandledErrorResponse } from './lib/http/handled-error-response';
export { httpErrorInterceptor } from './lib/http/http-error.interceptor';
export { type PtErrorType } from './lib/pt-error-type';
export { PctHttpErrorResponse } from './lib/http/pct-http-error-response';
export { showUnknownErrorDialog } from './lib/show-unknown-error-dialog';
export { messageDialogOptionsGenerator } from './lib/http/message-dialog-options-generator';
export { isBackendErrorWithMessage } from './lib/http/typeguard/is-backend-error-with-message';
